var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"profile-default",class:[
    { xs: _vm.size === 'xs', sm: _vm.size === 'sm', md: _vm.size === 'md', lg: _vm.size === 'lg', xl: _vm.size === 'xl',xxl: _vm.size==='xxl' },
    'bg-' + _vm.cirgleBgColor,
  ],attrs:{"title":_vm.fullName}},[_vm._v(" "+_vm._s(_vm.firstLetter)+_vm._s(_vm.secondLetter)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }